<template>
    <g>
        <path :fill="color1" d="M133.23,106.27a26.6,26.6,0,0,1-26.6,26.6H26.85A26.59,26.59,0,0,1,.26,106.27V26.49A26.59,26.59,0,0,1,26.85-.11h79.78a26.6,26.6,0,0,1,26.6,26.6Z" transform="translate(-0.26 0.11)"/>
        <path :fill="color2" d="M123.67,70.92a18,18,0,0,1-18,18H27.79a18,18,0,0,1-18-18V28.11a18,18,0,0,1,18-18h77.9a18,18,0,0,1,18,18Z" transform="translate(-0.26 0.11)"/>
        <path :fill="color2" d="M80.75,85.88l-11.57-.72v-.3L66.75,85l-2.45-.15v.3l-11.57.73,11.05,18a4.33,4.33,0,0,0,3,2,3.08,3.08,0,0,0,2.65-1.53,2.26,2.26,0,0,0,.31-.44Z" transform="translate(-0.26 0.11)"/>
        <path :fill="color1" d="M35.1,41.43a9.28,9.28,0,0,0-5.93,2.74V33.12h-7v29h7V59.89a6.69,6.69,0,0,0,5.86,3s9.82-.36,9.82-10.84C44.92,52.05,44.56,41.43,35.1,41.43ZM33.56,56.76A4.48,4.48,0,1,1,38,52.28,4.49,4.49,0,0,1,33.56,56.76Z" transform="translate(-0.26 0.11)"/>
        <path :fill="color1" d="M47.16,32.47v6.72s3.18-.14,3.18,5.78V62.16h6.72V43.38S57.35,32.47,47.16,32.47Z" transform="translate(-0.26 0.11)"/>
        <path :fill="color1" d="M73.49,41.52S62,41.52,62,52.28c0,0-.37,10.61,11.52,10.61,0,0,11.78,0,11.78-10.61C85.27,52.28,85.66,41.52,73.49,41.52Zm0,15.24A4.48,4.48,0,1,1,78,52.28,4.49,4.49,0,0,1,73.49,56.76Z" transform="translate(-0.26 0.11)"/>
        <path :fill="color1" d="M104.51,42.23v1.94a7.64,7.64,0,0,0-5.85-2.65S88.8,41.1,88.8,52.2c0,0-.11,10.34,9.59,10.34,0,0,4,.17,6.12-2.65v1.63s.49,5.09-4.45,5.09H98.39v6.18h2.7s10.19.1,10.19-10.9V42.23Zm-4.17,14.53a4.48,4.48,0,1,1,4.48-4.48A4.49,4.49,0,0,1,100.34,56.76Z" transform="translate(-0.26 0.11)"/>
    </g>
</template>

<script>
    export default {
        props: {
            color1: {
                type: String,
                default: '#285a78'
            },
            color2: {
                type: String,
                default: '#fff'
            }
        }
    };    
</script>
